
    <div class="nav-item">
   
      
        <div class="d-none d-xl-block ps-2 pt-1">
          <div class="text-white">
            {{ UserData?.givenName | titlecase }}
            {{ UserData?.surname | titlecase }}
          </div>
          <small class="pt-1 text-white-50">
            {{ UserData?.jobTitle | titlecase }}
          </small>
        </div>

        

  
      <!-- <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
        <a
        routerLink="/voc-tracker/new-entry"
          routerLinkActive="active"
          class="dropdown-item"
          >Create VOC</a
        >
        <div class="dropdown-divider"></div>
        <a routerLink="/voc-tracker/entry-list" class="dropdown-item">My VOC's</a>
        <div class="dropdown-divider"></div>

        <a *ngIf="UserStatus" (click)="logout()" class="dropdown-item"
          >Sign out</a
        > 
      </div> -->
    </div> 

